/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrderVideoEnum = 1 | 0;

export const OrderVideoEnum = {
    NUMBER_1: 1 as OrderVideoEnum,
    NUMBER_0: 0 as OrderVideoEnum
};

